var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLeadAssignment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.725,
    height: 10.725,
    viewBox: "0 0 10.725 10.725",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_person_24px",
    d: "M9.362,9.362A2.681,2.681,0,1,0,6.681,6.681,2.68,2.68,0,0,0,9.362,9.362Zm0,1.341C7.573,10.7,4,11.6,4,13.384v1.341H14.725V13.384C14.725,11.6,11.152,10.7,9.362,10.7Z",
    transform: "translate(-4 -4)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLeadAssignment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-lead-assignment.e955898b2dd7ccee6edbbd11d3574099.svg";